import { useSessionStore } from '@/shared/hooks/use-shallow-store';
import { useT } from '@/shared/lib/i18n';
import { AdaptiveDialog } from '@/shared/ui';
import { LobbyJoinForm } from './LobbyJoinForm';

export type JoinOnlineDialogProps = {
  open: true;
  onClose: () => void;
  onJoined: (code: string) => void;
};

export const JoinOnlineDialog = ({ open, onClose, onJoined }: JoinOnlineDialogProps) => {
  const t = useT();
  const setLobbyError = useSessionStore((s) => s.setLobbyError);

  const close = (): void => {
    setLobbyError(null);
    onClose();
  };

  return (
    <AdaptiveDialog open={open} onClose={close} ariaLabel={t('online.join.heading')}>
      <LobbyJoinForm onJoined={onJoined} onClose={close} />
    </AdaptiveDialog>
  );
};
